import JdIcon from '@jdesign-vue/components/icon'
import { MinusSquare, PlusSquare } from '@jd/jdesign-icons-vue'

import type { StyleValue } from 'vue'
import type { TableV2RowCellRenderParam } from './row'

const ExpandIcon = (
  props: TableV2RowCellRenderParam['expandIconProps'] & {
    class?: string | string[]
    style: StyleValue
    size: number
    expanded: boolean
    expandable: boolean
  }
) => {
  const { expanded, expandable, onExpand, style, size } = props

  const expandIconProps = {
    onClick: expandable ? () => onExpand(!expanded) : undefined,
    class: props.class,
  } as any

  return (
    <JdIcon {...expandIconProps} size={size} style={style}>
      {expanded ? <MinusSquare /> : <PlusSquare />}
    </JdIcon>
  )
}

export default ExpandIcon

export type ExpandIconInstance = ReturnType<typeof ExpandIcon>
